/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EAssociateCompanyTotalEmployees } from "../types/EAssociateCompanyTotalEmployees.ts";

/**
 * @description 1 = From0To50 | 2 = From50To100 | 3 = From100To500 | 4 = From500To1000 | 5 = HigherThan1000 |
 */
export const eAssociateCompanyTotalEmployeesSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = From0To50 | 2 = From50To100 | 3 = From100To500 | 4 = From500To1000 | 5 = HigherThan1000 | ",
  ) as unknown as ToZod<EAssociateCompanyTotalEmployees>;
